export const numberFromNumberOrString = (value: number | string): number =>
  typeof value === 'string' ? parseInt(value, 10) : value;
